import { ReactNode, useEffect, useState } from "react";
import Loader from "../../componentsNew/Loader/Loader";

interface ProtectedRouteProps {
  children: ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const checkAccess = async () => {
      try {
        // Step 1: Check authentication via Easy Auth
        const meRes = await fetch("/.auth/me");
        const meData = await meRes.json();
        if (!meData.clientPrincipal) {
          window.location.href = "/.auth/login/add";
          return;
        }

        // Step 2: Check if user is allowed (via backend)
        const accessRes = await fetch("/api/authAccess");
        if (accessRes.status === 200) {
          setAuthorized(true);
        } else {
          window.location.href = "/401";
        }
      } catch (err) {
        console.error("Access check failed:", err);
        window.location.href = "/401";
      } finally {
        setLoading(false);
      }
    };

    checkAccess();
  }, []);

  if (loading) return <Loader />;

  return authorized ? <>{children}</> : null;
}
